import type { Dash } from '@vp/shared-types';
import type { StyleSpec } from './model';

/** Map diagram style flags to platform stroke dash. */
export function strokeDash(style: StyleSpec, dotted = false): Dash {
  if (dotted) return 'dotted';
  if (style.fine) return 'fine';
  if (style.dashed) return 'dashed';
  return 'solid';
}
